<template>
  <div>
    <v-card-text>
      <p
        v-html="config.additional_info"></p>
    </v-card-text>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      content: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'config'
    ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AboutUs.vue